import { render, staticRenderFns } from "./PressRelease.vue?vue&type=template&id=d1a56e80&"
import script from "./PressRelease.vue?vue&type=script&lang=js&"
export * from "./PressRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports